import { Card } from '@/components/Surface'
import { SubPage } from '@/components/SubPage'
import { haptic, openTgLink } from '@/lib/tg'
import { motion } from 'motion/react'

const SUPPORT_USERNAME = 'CicxdaVPN_manager'
const SUPPORT_LINK = `https://t.me/${SUPPORT_USERNAME}`


const QUICK = [
  { label: 'не приходит оплата', subject: 'Оплата не прошла. Номер платежа: ...' },
  { label: 'не работает VPN', subject: 'Не подключается VPN. Устройство: ...' },
  { label: 'другой вопрос', subject: '' },
]

export function Support() {
  const openChat = (subject?: string) => {
    haptic('medium')
    const url = subject
      ? `${SUPPORT_LINK}?text=${encodeURIComponent(subject)}`
      : SUPPORT_LINK
    openTgLink(url)
  }

  return (
    <SubPage title="поддержка" subtitle="напишем — ответим">
      <div className="px-5 space-y-3 stagger">
        <Card className="p-5" style={{ ['--i' as never]: 0 }}>
          <div className="row">
            <div className="size-12 rounded-full bg-[var(--color-gold-soft)] border border-[var(--color-gold-deep)] flex items-center justify-center">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="var(--color-gold-bright)" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <path d="M4 12a8 8 0 1 1 4.6 7.2L4 20l.8-4.6A8 8 0 0 1 4 12z" />
              </svg>
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-[16px] font-semibold">@{SUPPORT_USERNAME}</div>
              <div className="text-[12.5px] text-[var(--color-muted)] mt-0.5">
                отвечаем ~10 минут, 9:00–22:00 МСК
              </div>
            </div>
          </div>
          <motion.button
            onClick={() => openChat()}
            whileTap={{ scale: 0.985 }}
            className="tap mt-4 w-full py-[16px] rounded-[6px] text-[13px] font-bold uppercase tracking-[0.14em] bg-[var(--color-crimson)] text-white"
          >
            открыть чат
          </motion.button>
        </Card>

        <div style={{ ['--i' as never]: 1 }}>
          <div className="text-[13px] text-[var(--color-muted)] mb-2 px-1">быстрая тема</div>
          <Card className="overflow-hidden">
            {QUICK.map((q, i) => (
              <motion.button
                key={q.label}
                onClick={() => openChat(q.subject)}
                whileTap={{ scale: 0.992 }}
                className="tap w-full text-left px-5 py-4 flex items-center gap-3"
                style={{ borderBottom: i < QUICK.length - 1 ? '1px solid var(--color-line)' : 'none' }}
              >
                <div className="flex-1 text-[14.5px] font-medium">{q.label}</div>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--color-dim)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9 6l6 6-6 6" />
                </svg>
              </motion.button>
            ))}
          </Card>
        </div>

        <div
          style={{ ['--i' as never]: 2 }}
          className="text-[12.5px] leading-relaxed text-[var(--color-muted)] px-1"
        >
          Прежде чем писать — загляни в{' '}
          <button
            onClick={() => {
              haptic('light')
              // navigate to faq — wouter Link would be nicer but for now just window
              window.history.pushState({}, '', '/profile/faq')
              window.dispatchEvent(new PopStateEvent('popstate'))
            }}
            className="text-[var(--color-ink)] font-semibold underline underline-offset-2"
          >
            базу знаний
          </button>{' '}
          — там собраны типовые вопросы и инструкции.
        </div>
      </div>
    </SubPage>
  )
}
